module.exports = __webpack_public_path__ + "static/img/fw2.8c27f30.png";


//////////////////
// WEBPACK FOOTER
// ./static/fw2.png
// module id = cBqj
// module chunks = 1